import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Col, Container, Row, Table } from "react-bootstrap";
import React from "react";
import GlobalActions from "../containers/GlobalActions";
import TableHeader from "../containers/TableHeader";
import { CursedPager } from "./CursedPager";
import TableBody from "../containers/TableBody";
import { Translate } from "react-redux-i18n";
import { ColumnType } from "../../kptable";
import { KSpinner, KSpinnerSize } from "../../KSpinner";
import { loadFromLS } from "../utils";
import GlobalWaiter from "../../kptable/containers/GlobalWaiter";
export const DEFAULT_PAGE_SIZES = [5, 10, 25, 50, 100];
export class KPTable extends React.Component {
    executeTimer(loadInterval) {
        if (this.timerStarted) {
            const { onCallLoaderFunc, id, loaderFunc } = this.props;
            this.idTimeout = setTimeout(async () => {
                await onCallLoaderFunc(id, loaderFunc, true);
                this.executeTimer(loadInterval);
            }, loadInterval);
        }
    }
    componentWillUnmount() {
        this.timerStarted = false;
        if (this.idTimeout) {
            clearTimeout(this.idTimeout);
        }
    }
    async componentDidMount() {
        const { data, keyField, cursorNext, onRegister, id, loadInterval, pageSizes = DEFAULT_PAGE_SIZES, children, filterDefinition } = this.props;
        const columnKeys = [];
        React.Children.forEach(children, (child) => {
            const { type, colid, hideable = true, visible = true } = child.props;
            if (type !== ColumnType.ACTIONS && hideable) {
                columnKeys.push({ colid, visible });
            }
        });
        this.setFilterEvents(filterDefinition);
        const partialState = loadFromLS(id);
        onRegister(id, {
            globalCheckedAll: false,
            globalChecked: false,
            refreshing: false,
            top: partialState.top || pageSizes[0],
            cursorNext: partialState.cursorNext || cursorNext || undefined,
            current: partialState.current || undefined,
            currentDirection: partialState.currentDirection || "next",
            cursorPrev: partialState.cursorPrev || undefined,
            firstElement: partialState.firstElement || (data && data.length > 0 ? data[0][keyField || "id"] : undefined),
            filter: {},
            checked: {},
            waiting: {},
            confirmation: {},
            columnVisibility: columnKeys.reduce((prev, key) => {
                prev[key.colid] = key.visible;
                return prev;
            }, {}),
            globalShowProgress: false,
            globalWaiting: false,
            globalProgress: 0,
            dirtyFilters: {},
            filtersOpened: false,
        });
        if (loadInterval) {
            this.timerStarted = true;
            this.executeTimer(loadInterval);
        }
    }
    setFilterEvents(filterDefinition) {
        const { id, onChangeDirtyFilter } = this.props;
        if (filterDefinition) {
            for (const filter of filterDefinition) {
                filter.setOnChange((name, value) => {
                    onChangeDirtyFilter(id, name, value);
                });
            }
        }
    }
    componentWillReceiveProps({ filterDefinition }) {
        this.setFilterEvents(filterDefinition);
    }
    render() {
        const { children, id, loaderFunc, table, checkboxes = false, pageSizes = DEFAULT_PAGE_SIZES, onGoToPrev, onGoToNext, onGoToFirst, onChangePageSize, onChangeGlobalCheckAll, keyField = "id", data, waiter, hideColumnSelector = false, hideFilters = false, globalActions, globalWaiter, filterDefinition, variableColumns, hidePager = false, noMinHeight = false, rowAction, } = this.props;
        if (!table) {
            return null;
        }
        return (_jsxs(Container, { fluid: true, className: `kptableholder`, children: [table.globalChecked ? (_jsx(Alert, { variant: "warning", className: table.refreshing || table.globalWaiting ? "light-blur" : "", children: !table.globalCheckedAll ? (_jsxs("div", { className: "globalAlert text-center", children: [_jsx(Translate, { value: "kptable.globalSelectionWarn1" }), _jsx("span", { className: "globalSelectionLabel", onClick: () => onChangeGlobalCheckAll(id, true), children: _jsx(Translate, { value: "kptable.globalSelectionWarnAll" }) }), _jsx("br", {}), _jsx(Translate, { value: "kptable.globalSelectionFilterWarn1" })] })) : (_jsxs("div", { className: "globalAlert text-center", children: [_jsx(Translate, { value: "kptable.globalSelectionWarn2" }), _jsx("span", { className: "globalSelectionLabel", onClick: () => onChangeGlobalCheckAll(id, false), children: _jsx(Translate, { value: "kptable.globalSelectionWarnNotAll" }) }), _jsx("br", {}), _jsx(Translate, { value: "kptable.globalSelectionFilterWarn2" })] })) })) : null, _jsx(GlobalActions, { id: id, hideColumnSelector: hideColumnSelector, hideFilters: hideFilters, globalActions: globalActions, data: data, keyField: keyField, loaderFunc: loaderFunc, filterDefinition: filterDefinition, variableColumns: variableColumns, className: table.refreshing || table.globalWaiting ? "light-blur" : "", children: children }), _jsx(Row, { className: `kptablerow${noMinHeight ? " no-min-height" : ""} ${table.refreshing || table.globalWaiting ? "light-blur" : ""}`, children: _jsxs(Table, { responsive: true, className: `kptable`, children: [_jsx(TableHeader, { id: id, loaderFunc: loaderFunc, checkboxes: checkboxes, keyField: keyField, data: data, variableColumns: variableColumns, children: children }), _jsx(TableBody, { id: id, keyField: keyField, data: data, loaderFunc: loaderFunc, checkboxes: checkboxes, variableColumns: variableColumns, rowAction: rowAction, children: children })] }) }), _jsx(Row, { className: `kpfooter ${table.refreshing || table.globalWaiting ? "light-blur" : ""}`, children: !hidePager ? (_jsx(Col, { sm: { span: 10 }, md: { span: 6 }, children: _jsx(CursedPager, { id: id, cursorNext: table.cursorNext, current: table.current, cursorPrev: table.cursorPrev, firstElement: table.firstElement, pageSize: table.top, pageSizes: pageSizes, onGoToFirstPage: () => onGoToFirst(id, loaderFunc), onGoToNextPage: () => onGoToNext(id, loaderFunc), onGoToPrevPage: () => onGoToPrev(id, loaderFunc), onChangePageSize: (newPageSize) => onChangePageSize(id, newPageSize, loaderFunc) }) })) : null }), table.refreshing ? (_jsx("div", { className: "kpwaiter", children: _jsx("div", { className: "kpspinner", children: waiter || _jsx(KSpinner, { size: KSpinnerSize.xl }) }) })) : null, _jsx(GlobalWaiter, { id: id, waiter: globalWaiter })] }));
    }
}
